function Contacto() {
  return (
    <main style={{ padding: "2rem" }}>
      <h1>Contáctanos</h1>
      <p>
        Puedes comunicarte con nosotros llenando el siguiente formulario o usando los medios de contacto disponibles.
      </p>

      <form style={{ marginTop: "2rem", maxWidth: "400px" }}>
        <div style={{ marginBottom: "1rem" }}>
          <label htmlFor="nombre">Nombre:</label>
          <input
            type="text"
            id="nombre"
            name="nombre"
            style={{ width: "100%", padding: "0.5rem", marginTop: "0.3rem" }}
          />
        </div>
        <div style={{ marginBottom: "1rem" }}>
          <label htmlFor="correo">Correo electrónico:</label>
          <input
            type="email"
            id="correo"
            name="correo"
            style={{ width: "100%", padding: "0.5rem", marginTop: "0.3rem" }}
          />
        </div>
        <div style={{ marginBottom: "1rem" }}>
          <label htmlFor="mensaje">Mensaje:</label>
          <textarea
            id="mensaje"
            name="mensaje"
            rows="4"
            style={{ width: "100%", padding: "0.5rem", marginTop: "0.3rem" }}
          ></textarea>
        </div>
        <button type="submit" style={{ padding: "0.7rem 1.2rem" }}>
          Enviar
        </button>
      </form>
    </main>
  );
}

export default Contacto;
